import React, { useState } from 'react';

import { Alert } from 'antd';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import styled from 'styled-components';

import { datePickerToApi, getNow } from '@libs/NwMoment';

import { forceReloadPayments, useAddNewPayment } from '@hooks/API/UsePayments';

import { useStatementContext } from '@components/ContactsStatement/StatementContext';
import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWDatePicker, NWInput } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';
import StyleVariables from '@components/Gui/StyleVariables.js';

const PaymentContent = styled.div`
    .contact-name {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 40px;
    }
    .bold-text {
        font-weight: bold;
    }
    .statements-content {
        margin-bottom: 40px;
        .contact-row {
            display: flex;
            flex-direction: row;
            font-size: 12px;
            .select-all {
                color: ${StyleVariables.PrimaryColor};
                margin-left: 10px;
                cursor: pointer;
                user-select: none;
            }
        }
        .tx-details {
            font-size: 12px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .ant-checkbox-wrapper {
                font-size: 12px;
            }
        }
    }
`;
const CreatePaymentDrawer = ({ onClose, data, onReload, onPaymentCreated }) => {
    //onReload
    const [touchForm, setTouchForm] = useState(false);
    const { mutateAsync: onAddNewPayment } = useAddNewPayment();
    const [errorCreating, setErrorCreating] = useState(null);

    //const cs_dispatch = useStatementsContext();
    // const onReload = () => {
    //     cs_dispatch({ type: 'StartReload' });
    // };

    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let randomCode = '';
    for (let i = 0; i < 4; i++) {
        const randomIndex = Math.floor(Math.random() * uppercaseChars.length);
        randomCode += uppercaseChars[randomIndex];
    }

    const paymentDate = getNow();
    const paymentName = 'Payment';
    const paymentNumber = paymentDate.format('YYYY-MM-DD') + '-' + randomCode;

    const initialValues = {
        Name: paymentName,
        Number: paymentNumber,
        Date: paymentDate,
    };

    const savePayment = async (values, setSubmitting) => {
        setSubmitting(true);
        try {
            const paymentID = await onAddNewPayment({
                data: {
                    ContactID: data.ContactID,
                    BillingInfoID: data.BillingInfoID ? data.BillingInfoID : null,
                    Name: values.Name,
                    Type: data.Type,
                    Currency: data.Currency,
                    StatementIDs: data.StatementIDs,
                    Number: values.Number,
                    Date: values.Date && datePickerToApi(values.Date),
                },
            });
            forceReloadPayments(data.ContactID);
            if (onPaymentCreated) {
                onPaymentCreated(paymentID);
            }
            if (onReload) {
                onReload();
            }
            onClose();
            setSubmitting(false);
        } catch (e) {
            setErrorCreating('Error creating payment. Please try again with another number/code.');
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} onClose={onClose} title="Create Model Payment">
            <PaymentContent>
                <Formik
                    initialValues={initialValues}
                    onSubmit={(values, { setSubmitting }) => {
                        savePayment(values, setSubmitting);
                    }}
                    validationSchema={Yup.object().shape({
                        Name: Yup.string().required('Title is required'),
                        Number: Yup.string().required('Number is required'),
                        Date: Yup.date().required('Date is required'),
                    })}
                >
                    {({ isSubmitting, values, handleSubmit }) => (
                        <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit}>
                            <Field
                                component={NWInput}
                                label="Payment Title"
                                name="Name"
                                maxLength={50}
                                type="text"
                                value={values.Name}
                            />
                            <Field
                                component={NWInput}
                                label="Payment Code"
                                name="Number"
                                maxLength={50}
                                type="text"
                                value={values.Number}
                            />
                            <Field
                                component={NWDatePicker}
                                label="Date"
                                name="Date"
                                format="MMM DD, YYYY"
                                allowClear={false}
                                value={values.Date}
                            />
                            {errorCreating && (
                                <Alert style={{ margin: '1rem 0' }} message={errorCreating} type="error" />
                            )}
                            <NwFormButtonsBar
                                marginTop="4rem"
                                left={
                                    <NwCancelButton
                                        disabled={isSubmitting}
                                        onClick={() => {
                                            setTouchForm(false);
                                            onClose();
                                        }}
                                    />
                                }
                                right={<NwSaveButton htmlType="submit" loading={isSubmitting} />}
                            />
                        </NwForm>
                    )}
                </Formik>
            </PaymentContent>
        </NwDrawer>
    );
};

export default CreatePaymentDrawer;
